module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/项目配图1.d67fc775.png";